import { CatalogDialog, SECONDARY_BUTTON } from './CatalogDialog';

/**
 * The disable refusal (task 1102). The service answers a disable that Model
 * Configs still depend on with 409 and the list of those configs; this names
 * them. There is no force-disable: Close is the only action.
 */
interface ProviderDisableBlockedDialogProps {
  /** Null when closed. */
  blocked: { providerName: string; configNames: string[]; message: string | null; defaultProvider?: boolean } | null;
  onClose: () => void;
}

export function ProviderDisableBlockedDialog({ blocked, onClose }: ProviderDisableBlockedDialogProps) {
  return (
    <CatalogDialog
      open={blocked !== null}
      onClose={onClose}
      title={blocked ? `${blocked.providerName} cannot be disabled` : 'Provider cannot be disabled'}
      testId="provider-disable-blocked-dialog"
    >
      {blocked && (
        <div className="space-y-3 text-sm text-gray-700 dark:text-gray-200">
          {blocked.defaultProvider && blocked.configNames.length > 0 && blocked.message && <p>{blocked.message}</p>}
          {blocked.configNames.length > 0 ? (
            <>
              <p>These Model Configs depend on {blocked.providerName}:</p>
              <ul className="list-disc space-y-0.5 pl-5" data-testid="provider-disable-blocking-list">
                {blocked.configNames.map((name) => (
                  <li key={name} className="font-mono">
                    {name}
                  </li>
                ))}
              </ul>
              <p>Remove those dependencies before disabling.</p>
            </>
          ) : (
            <p>{blocked.message ?? `Model Configs depend on ${blocked.providerName}. Remove those dependencies before disabling.`}</p>
          )}
        </div>
      )}
      <div className="flex justify-end pt-6">
        <button type="button" onClick={onClose} className={SECONDARY_BUTTON}>
          Close
        </button>
      </div>
    </CatalogDialog>
  );
}
